export default "__VITE_ASSET__BCEjl0a9__"